import { useSelector } from '@xstate/react';

import { useEssentialMachines } from '../../EssentialMachines';

// ─────────────────────────────────────────────────────────────────────────────

export const useSessionError = () => {
  const { authMachineRef } = useEssentialMachines();

  return useSelector(authMachineRef, (state) => state.context.sessionError);
};
